import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import {
  CalculateByDays,
  CLEAR_COSTS,
  ForSubmit,
  GET,
  CREATE,
  UPDATE,
  REMOVE,
  AdditionalInformation,
  GETCATEGORYSERVICEREQUEST,
  GETCATEGORYSUBITEMS,
  CREATECATEGORYSPLIT,
  RESOLVECATEGORYREQUEST,
  REOPENCATEGORYREQUEST,
  GET_FOOTER,
  CLEAR_FOOTER,
  CALCULATE_BY_DAYS_FROM_CATALOG,
  CONFIRM,
  GET_INTERNAL_PENDING_FLAG,
  UPDATE_INTERNAL_PENDING_FLAG,
  UPDATE_ACTIVITY,
  GET_EXCLUDE_FROM_FSOR_CONFIRMATION,
  UPDATE_EXCLUDE_FROM_FSOR_CONFIRMATION,
  UPDATE_GENERAL_ATTACHMENTS,
  UPDATE_IS_FULLY_ORDERED,
  GET_IS_FULLY_ORDERED,
  VALIDATE_SERVICE_REQUESTS_FOR_COPY,
  GET_DATA_FOR_COPY_SUBMIT,
  COPY_SERVICE_REQUESTS,
  VALIDATE_EXERCISE_FOR_SR_COPY,
  ROLLBACK_SERVICE_REQUEST
} from '@hobs/constants/serviceRequests';
import { actionCreator } from './utils/utils';

export function getAdditionalInformation(serviceRequestId) {
  return (dispatch, getState) => {
    const state = getState();
    const additionalInformation =
      state.serviceRequests.additionalInformation[serviceRequestId];
    if (additionalInformation) {
      return { success: true, payload: additionalInformation };
    }
    dispatch(request());

    return fetchSecure(
      `ServiceRequests/${serviceRequestId}/AdditionalInformation`
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: AdditionalInformation.REQUEST };
  }
  function success(results) {
    return { type: AdditionalInformation.SUCCESS, results };
  }
  function failure(error) {
    return { type: AdditionalInformation.FAILURE, error };
  }
}

export const calculateByDaysForSplit = body =>
  actionCreator(
    'ServiceRequests/CalculateByDaysFromCatalog',
    CALCULATE_BY_DAYS_FROM_CATALOG,
    {
      body,
      method: 'POST'
    }
  );

export function calculateByDays(body) {
  return dispatch => {
    dispatch(request());

    return fetchSecure('ServiceRequests/CalculateByDays', {
      body: body,
      method: 'POST'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CalculateByDays.REQUEST };
  }
  function success(results) {
    return { type: CalculateByDays.SUCCESS, results };
  }
  function failure(error) {
    return { type: CalculateByDays.FAILURE, error };
  }
}

export function clearCalculateByDays() {
  return dispatch => {
    dispatch({ type: CLEAR_COSTS.SUCCESS });
  };
}

export function forSubmit(partyId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(`ServiceRequests/ForSubmit/${partyId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: ForSubmit.REQUEST };
  }
  function success(results) {
    return { type: ForSubmit.SUCCESS, results };
  }
  function failure(error) {
    return { type: ForSubmit.FAILURE, error };
  }
}

export function getServiceRequest(serviceRequestsId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(`ServiceRequests/${serviceRequestsId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET.REQUEST };
  }

  function success(item) {
    return { type: GET.SUCCESS, item };
  }
  function failure(error) {
    return { type: GET.FAILURE, error };
  }
}

export function create(data) {
  return dispatch => {
    dispatch(request());

    return fetchSecure('ServiceRequests', { body: data, method: 'POST' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CREATE.REQUEST };
  }
  function success(results) {
    return { type: CREATE.SUCCESS, results };
  }
  function failure(error) {
    return { type: CREATE.FAILURE, error };
  }
}

export function update(data) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`ServiceRequests/${data.serviceRequestId}`, {
      body: data,
      method: 'PUT'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UPDATE.REQUEST };
  }

  function success() {
    return { type: UPDATE.SUCCESS };
  }
  function failure(error) {
    return { type: UPDATE.FAILURE, error };
  }
}

export function remove(partyId, serviceRequestId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `StatementOfRequirements/${partyId}/ServiceRequests/${serviceRequestId}`,
      { method: 'DELETE' }
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success());

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: REMOVE.REQUEST };
  }
  function success() {
    return { type: REMOVE.SUCCESS };
  }
  function failure(error) {
    return { type: REMOVE.FAILURE, error };
  }
}

export function getCategoryServiceRequest(serviceRequestsId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      `ServiceRequests/${serviceRequestsId}/CategoryServiceRequestDetails`
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GETCATEGORYSERVICEREQUEST.REQUEST };
  }

  function success(item) {
    return { type: GETCATEGORYSERVICEREQUEST.SUCCESS, item };
  }
  function failure(error) {
    return { type: GETCATEGORYSERVICEREQUEST.FAILURE, error };
  }
}

export function getCategorySubitems(code) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(`ServiceRequests/CategorySubitems/${code}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GETCATEGORYSUBITEMS.REQUEST };
  }
  function success(payload) {
    return { type: GETCATEGORYSUBITEMS.SUCCESS, payload: payload };
  }
  function failure(error) {
    return { type: GETCATEGORYSUBITEMS.FAILURE, error };
  }
}

export function createCategorySplit(data) {
  return dispatch => {
    dispatch(request());

    return fetchSecure('ServiceRequests/SplitCategoryServiceRequest', {
      body: data,
      method: 'POST'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CREATECATEGORYSPLIT.REQUEST };
  }
  function success(results) {
    return { type: CREATECATEGORYSPLIT.SUCCESS, results };
  }
  function failure(error) {
    return { type: CREATECATEGORYSPLIT.FAILURE, error };
  }
}

export function resolveCategoryRequest(sorId, serviceRequestId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      `StatementOfRequirements/${sorId}/ResolveCategoryRequest/${serviceRequestId}`,
      { method: 'POST' }
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: RESOLVECATEGORYREQUEST.REQUEST };
  }
  function success(results) {
    return { type: RESOLVECATEGORYREQUEST.SUCCESS, results };
  }
  function failure(error) {
    return { type: RESOLVECATEGORYREQUEST.FAILURE, error };
  }
}

export function reopenCategoryRequest(sorId, serviceRequestId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      `StatementOfRequirements/${sorId}/ReopenCategoryRequest/${serviceRequestId}`,
      { method: 'POST' }
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: REOPENCATEGORYREQUEST.REQUEST };
  }
  function success(results) {
    return { type: REOPENCATEGORYREQUEST.SUCCESS, results };
  }
  function failure(error) {
    return { type: REOPENCATEGORYREQUEST.FAILURE, error };
  }
}

export const getFooter = serviceRequestId =>
  actionCreator(`ServiceRequest/${serviceRequestId}/Footer`, GET_FOOTER);

export const confirmServiceRequest = serviceRequestId =>
  actionCreator(`ServiceRequest/${serviceRequestId}/Confirm`, CONFIRM, {
    method: 'PUT'
  });

export function clearFooter() {
  return dispatch => {
    dispatch({ type: CLEAR_FOOTER.SUCCESS });
  };
}

export const getInternalPendingFlag = serviceRequestId =>
  actionCreator(
    `ServiceRequest/${serviceRequestId}/InternalPendingFlag`,
    GET_INTERNAL_PENDING_FLAG
  );

export const updateInternalPendingFlag = (serviceRequestId, body) =>
  actionCreator(
    `ServiceRequest/${serviceRequestId}/UpdateInternalPendingFlag`,
    UPDATE_INTERNAL_PENDING_FLAG,
    {
      body,
      method: 'PUT'
    }
  );

export const updateActivity = (sorId, serviceRequestId, body) =>
  actionCreator(
    `StatementOfRequirements/${sorId}/ServiceRequests/${serviceRequestId}/Activity`,
    UPDATE_ACTIVITY,
    {
      body: body,
      method: 'PUT'
    }
  );

export const getExcludeFromFsorConfirmation = serviceRequestId =>
  actionCreator(
    `ServiceRequests/${serviceRequestId}/ExcludeFromFsorConfirmation`,
    GET_EXCLUDE_FROM_FSOR_CONFIRMATION
  );

export const updateExcludeFromFsorConfirmation = (serviceRequestId, body) =>
  actionCreator(
    `ServiceRequests/${serviceRequestId}/ExcludeFromFsorConfirmation`,
    UPDATE_EXCLUDE_FROM_FSOR_CONFIRMATION,
    {
      body: body,
      method: 'PUT'
    }
  );

export const updateGeneralAttachments = (serviceRequestId, body) =>
  actionCreator(
    `AssignmentServiceRequest/${serviceRequestId}/GeneralAttachments`,
    UPDATE_GENERAL_ATTACHMENTS,
    {
      body: body,
      method: 'PUT'
    }
  );

export const getIsFullyOrdered = serviceRequestId =>
  actionCreator(
    `AssignmentServiceRequest/${serviceRequestId}/IsFullyOrdered`,
    GET_IS_FULLY_ORDERED
  );

export const updateIsFullyOrdered = (serviceRequestId, body) =>
  actionCreator(
    `AssignmentServiceRequest/${serviceRequestId}/IsFullyOrdered`,
    UPDATE_IS_FULLY_ORDERED,
    {
      body: body,
      method: 'PUT'
    }
  );

export function validateServiceRequestsForCopy(data) {
  return dispatch => {
    dispatch(request());

    return fetchSecure('ServiceRequests/ValidateForCopy', {
      body: data,
      method: 'POST'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: VALIDATE_SERVICE_REQUESTS_FOR_COPY.REQUEST };
  }
  function success(results) {
    return { type: VALIDATE_SERVICE_REQUESTS_FOR_COPY.SUCCESS, results };
  }
  function failure(error) {
    return { type: VALIDATE_SERVICE_REQUESTS_FOR_COPY.FAILURE, error };
  }
}

export function getDataForCopySubmit(exerciseId, partyId, data) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      `ServiceRequests/ForCopySubmit/${exerciseId}${
        partyId ? `/${partyId}` : ''
      }`,
      {
        body: data,
        method: 'POST'
      }
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET_DATA_FOR_COPY_SUBMIT.REQUEST };
  }
  function success(results) {
    return { type: GET_DATA_FOR_COPY_SUBMIT.SUCCESS, results };
  }
  function failure(error) {
    return { type: GET_DATA_FOR_COPY_SUBMIT.FAILURE, error };
  }
}

export function copyServiceRequests(data) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(`ServiceRequests/Copy`, { body: data, method: 'POST' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: COPY_SERVICE_REQUESTS.REQUEST };
  }
  function success(results) {
    return { type: COPY_SERVICE_REQUESTS.SUCCESS, results };
  }
  function failure(error) {
    return { type: COPY_SERVICE_REQUESTS.FAILURE, error };
  }
}

export const validateExerciseForSrCopy = (exerciseId, partyId) =>
  actionCreator(
    `ServiceRequests/ValidateExerciseForCopy/${exerciseId}${
      partyId ? `/${partyId}` : ''
    }`,
    VALIDATE_EXERCISE_FOR_SR_COPY
  );

export const rollbackServiceRequest = serviceRequestId =>
  actionCreator(
    `ServiceRequests/${serviceRequestId}/Rollback`,
    ROLLBACK_SERVICE_REQUEST
  );
